import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProduitRoutingModule } from './produit-routing.module';
import { ProduitComponent } from './produit.component';
import { MaterialModule } from 'src/app/material/material.module';
import { CookieService } from 'ngx-cookie-service';
import { CardProduitModule } from 'src/app/cardProduit/cardProduit.module';

@NgModule({
  declarations: [ProduitComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ProduitRoutingModule,
    CardProduitModule,
  ],
  providers: [CookieService],
})
export class ProduitModule {}
